import Blazy from '../../../managers/blazy';
import {hasClass} from '../../../util/dom-helpers';

export default class {
  constructor(context) {
    // Set Context
    this._context = context;

    // Set State Values
    this._dropdowns = this._context.querySelectorAll('.dropdown');
    this._navButtons = this._context.querySelectorAll('[data-element="nav"]');
    this._dropdownActiveClass = "mobile-active";

    // Initialise component
    this.init();
  }

  init() {
    
    const container = this._context.parentElement;
    const containerWith = container.offsetWidth;
    if (this._dropdowns.length > 0) {
      for (let dropdown of this._dropdowns) {
        const parent = dropdown.parentElement;
        const parentOffset = parent.offsetLeft;
        const parentWidth = parent.offsetWidth;

        const limitedDistance = containerWith - parentOffset - parentWidth;
        const dropdownWidth = dropdown.offsetWidth;

        if (dropdownWidth > limitedDistance) {
          if (!hasClass(dropdown, "aligned")) { dropdown.parentElement.className += " aligned" }
        } else
          if (hasClass(dropdown, "aligned")) { dropdown.parentElement.className -= " aligned" }
      }
    }

    if (this._navButtons.length > 0) {
      for (let navButton of this._navButtons) {
        navButton.addEventListener('click', event => this.toggleDropdown(event));
        navButton.addEventListener('mouseover', event => this.handleImageLazyLoading(event));
      }
    }
  }

  toggleDropdown(event) {
    let dropdown = event.target.querySelector('[data-component="Megamenu"]');
    if (dropdown) {
      dropdown.classList.add(this._dropdownActiveClass);
    }
    this.handleImageLazyLoading(event);
  }

  handleImageLazyLoading = (event) => {
    const featuredContent = event.target.parentNode.querySelector('.site-navigation__featured');
    
    if (featuredContent) {
      const featuredContentImageHolders = [...featuredContent.querySelectorAll('.site-navigation__imageHolder')];
      const imageHolderHiddenClass = 'site-navigation__imageHolder--hidden';
      const allFeaturedImagesHidden = featuredContentImageHolders.every(featuredContentImageHolder => featuredContentImageHolder.classList.contains(imageHolderHiddenClass));
      
      if (featuredContentImageHolders && allFeaturedImagesHidden) {
        featuredContentImageHolders.forEach(featuredContentImageHolder => {
          featuredContentImageHolder.classList.remove(imageHolderHiddenClass);
        });
        Blazy.revalidate();
      }
    }
  }
}
